import s from './CategoryList.module.scss';
import CategoryCardTop from '../../../components/CategoryCardTop/CategoryCardTop';
import { Helmet } from 'react-helmet-async';
import { useLocation } from "react-router-dom";

const CategoryList = () => {
  const location = useLocation();
  return (
    <>
    {location.pathname === "/categories" && (
        <Helmet>
          <title>カテゴリー – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
          <meta property="og:title" content="カテゴリー – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
          <meta property="og:image" content={`${process.env.REACT_APP_URL}/og-image.png`} />
          <meta property="og:url" content={`${process.env.REACT_APP_URL}/categories`} />
          <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
          <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
        </Helmet>
      )}
    <div className={s.root}>
      <div className={s.titleContainer}>
        <span>Search by Category</span>
        <h2>カテゴリーから探す</h2>
      </div>
      <CategoryCardTop />
    </div>
    </>
  );
};

export default CategoryList;
